module.exports = __webpack_public_path__ + "img/one_year_ar.0d77c445.jpg";